import sanitizeHtml from 'sanitize-html';

export function sanitizeSection(htmlName){
    return sanitizeHtml(htmlName, {
        allowedAttributes: Object.assign({},
            sanitizeHtml.defaults.allowedAttributes, {
                i: ['class']
            })});
};

export function sanitizeMarkup(htmlName){
    return sanitizeHtml(htmlName, {
        allowedAttributes: Object.assign({},
            sanitizeHtml.defaults.allowedAttributes)});
};


